import Vue from 'vue'
import Router from 'vue-router'
import { store } from './store'
import { FactoryTrack, ScreenName } from './constant/firebase.js'

Vue.use(Router)

/**
 * 各Viewページを読み込む
 * @param {String} view
 */
function loadView(view) {
  return () =>
    import(/* webpackChunkName: "view-[request]" */ `@/views/${view}.vue`)
}

const router = new Router({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/notification',
      name: 'NotificationAtStartup',
      component: loadView('NotificationAtStartup')
    },
    {
      path: '/home',
      name: 'Home',
      component: loadView('home/Home')
    },
    {
      path: '/home/news-redirect',
      name: 'HomeRedirectDetail',
      component: loadView('home/HomeRedirectDetail')
    },
    {
      path: '/home/news',
      name: 'HomeDetail',
      component: loadView('home/HomeDetail')
    },
    {
      // 詳細ページURLをIDを利用する
      path: '/home/:id',
      name: 'HomeDetail',
      component: loadView('home/HomeDetail'),
      props: route => ({ type: route.query.type })
    },
    {
      path: '/coupon',
      name: 'Coupon',
      component: loadView('Coupon'),
      props: route => ({ conditionProp: route.query.condition })
    },
    {
      path: '/detail',
      name: 'Detail',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: loadView('Detail')
    },
    {
      path: '/loading-screen',
      name: 'LoadingScreen',
      component: () => import('./views/LoadingScreen.vue'),
      props: true
    },
    {
      path: '/error-message',
      name: 'errorMessage',
      component: () => import('./views/ErrorMessage.vue'),
      props: route => ({
        id: route.query.id,
        actionName: route.query.actionName,
        isUsed: route.query.isUsed,
        typeProp: route.query.typeProp
      })
    },
    {
      path: '/location',
      name: 'location',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: loadView('Location')
    },
    {
      path: '/walk-through',
      name: 'WalkThrough',
      component: loadView('WalkThrough')
    },
    {
      path: '/registration',
      name: 'Registration',
      component: loadView('Registration')
    },
    {
      path: '/coupon/:id',
      name: 'useCoupon',
      component: loadView('UseCoupon'),
      props: route => ({ type: route.query.type })
    },
    {
      path: '/faq',
      name: 'FAQ',
      component: loadView('FAQ')
    },
    {
      path: '/faq/basic-setting',
      name: 'FAQBasicSetting',
      component: loadView('FAQBasicSetting')
    },
    {
      path: '/faq/collect-stamp',
      name: 'FAQCollectStamp',
      component: loadView('FAQCollectStamp')
    },
    {
      path: '/faq/use-coupon',
      name: 'FAQUseCoupon',
      component: loadView('FAQUseCoupon')
    },
    {
      path: '/faq/stamp',
      name: 'FAQStamp',
      component: loadView('FAQStamp')
    },
    {
      path: '/faq/read-error',
      name: 'FAQReadError',
      component: loadView('FAQReadError')
    },
    {
      path: '/faq/app-setting',
      name: 'FAQAppSetting',
      component: loadView('FAQAppSetting')
    },
    {
      path: '/faq/model-change',
      name: 'FAQModelChange',
      component: loadView('FAQModelChange')
    },
    {
      path: '/faq/contact-us',
      name: 'FAQContact',
      component: loadView('FAQContact')
    },
    {
      path: '/faq/invitation',
      name: 'FAQInvitation',
      component: loadView('FAQInvitation')
    },
    {
      path: '/faq/android',
      name: 'FAQAndroid',
      component: loadView('FAQAndroid')
    },
    {
      path: '/faq/inquiry',
      name: 'FAQInquiry',
      component: loadView('FAQInquiry')
    },
    {
      path: '/faq/next_android',
      name: 'FAQNextAndroid',
      component: loadView('FAQNextAndroid')
    },
    {
      path: '/faq/premium',
      name: 'FAQPremium',
      component: loadView('FAQPremium')
    },
    {
      path: '/faq/walk',
      name: 'AboutWalk',
      component: loadView('FAQWalk')
    },
    {
      path: '/faq/stamp_support',
      name: 'FAQStampSupport',
      component: loadView('FAQStampSupport')
    },
    {
      path: '/faq/walk/faq',
      name: 'WalkFAQ',
      component: loadView('FAQWalkFAQ')
    },
    {
      path: '/faq/loginbonus',
      name: 'LoginBonusFQQ',
      component: loadView('FAQLoginBonus')
    },
    {
      path: '/faq/reset-stamp',
      name: 'ResetStampFAQ',
      component: loadView('FAQResetStamp')
    },
    {
      path: '/profile-setting',
      name: 'ProfileSetting',
      component: loadView('ProfileSetting')
    },
    {
      path: '/popup-home',
      name: 'PopupHome',
      component: loadView('PopupHome')
    },
    {
      path: '/prizes',
      name: 'Prizes',
      component: loadView('Prizes')
    },
    {
      path: '/data-inherit',
      name: 'DataInherit',
      component: loadView('DataInherit')
    },
    {
      path: '/data-inherit-input',
      name: 'DataInheritInput',
      component: loadView('DataInheritInput')
    },
    {
      path: '/invitation-lp',
      name: 'InvitationLp',
      component: loadView('InvitationLp')
    },
    {
      path: '/invitation-info',
      name: 'FAQInvitationInfo',
      component: loadView('FAQInvitationInfo')
    },
    {
      path: '/stamphistory',
      name: 'StampHistory',
      component: loadView('StampHistory')
    },
    {
      path: '/stamphistory/monthly',
      name: 'StampHistoryMonthly',
      component: loadView('StampHistoryMonthly')
    },
    {
      path: '/stamphistory/card/:id',
      name: 'StampHistoryCard',
      component: loadView('StampHistoryCard')
    },
    {
      path: '/premium/interlude',
      name: 'PremiumInterlude',
      component: loadView('PremiumInterlude'),
      props: route => ({ conditionProp: route.query.condition })
    },
    {
      path: '/premium/coupon',
      name: 'PremiumCoupon',
      component: loadView('PremiumCoupon'),
      props: route => ({ conditionProp: route.query.condition })
    },
    {
      path: '/walk',
      name: 'Walk',
      component: loadView('Walk/index'),
      props: route => ({ conditionProp: route.query.condition })
    },
    {
      path: '/walk/about',
      name: 'AboutWalk',
      component: loadView('FAQWalk'),
      props: route => ({ conditionProp: route.query.condition })
    },
    {
      path: '/net-shop',
      name: 'NetShop',
      component: loadView('NetShop/NetShop')
    },
    {
      path: '/loginbonus',
      name: 'loginBonus',
      component: loadView('LoginBonus/index'),
      props: route => ({ conditionProp: route.query.condition })
    },
    {
      path: '/loginbonus/history',
      name: 'loginBonusHistory',
      component: loadView('LoginBonus/allHistory'),
      props: route => ({ conditionProp: route.query.condition })
    },
    {
      path: '/line-login',
      name: 'LineLogin',
      component: loadView('LineLogin')
    },
    {
      path: '/faq/ios',
      name: 'FAQiOS',
      component: loadView('FAQiOS')
    },
    {
      path: '/siwa',
      name: 'SIWA',
      component: loadView('SIWA')
    },
    {
      path: '/faq/account-delete',
      name: 'FAQAccountDelete',
      component: loadView('FAQAccountDelete')
    },
    {
      path: '/accountDelete',
      name: 'AccountDelete',
      component: loadView('AccountDelete')
    },
    {
      path: '/faq/ios530',
      name: 'FAQiOS530',
      component: loadView('FAQiOS530')
    },
    {
      path: '/mypage',
      name: 'MyPage',
      component: loadView('MyPage'),
      props: route => ({ conditionProp: route.query.condition })
    },
    {
      path: '/delivery',
      name: 'Delivery',
      component: loadView('Delivery')
    },
    {
      path: '/takeout',
      name: 'TakeOut',
      component: loadView('TakeOut')
    },
    {
      path: '/netorder',
      name: 'NetOrder',
      component: loadView('NetOrder')
    },
    {
      path: '/seal',
      name: 'Seal',
      component: loadView('Seal'),
      props: true
    },
    {
      path: '/faq/seal',
      name: 'FAQSeal',
      component: loadView('FAQSeal')
    },
    {
      path: '/coupon-with-cart',
      name: 'CouponWithCart',
      component: loadView('CouponWithCart/index')
    },
    {
      path: '/coupon-with-cart/:id',
      name: 'CouponWithCartDetail',
      component: loadView('CouponWithCart/Detail')
    },
    {
      path: '/premium/lounge',
      name: 'PremiumLounge',
      component: loadView('PremiumLounge'),
      props: route => ({ conditionProp: route.query.condition })
    },
    {
      path: '/previousseal',
      name: 'PreviousSeal',
      component: loadView('PreviousSeal')
    },
    {
      path: '/gacha',
      name: 'Gacha',
      component: loadView('Gacha/index')
    },
    {
      path: '/gacha/notify',
      name: 'GachaNotify',
      component: loadView('Gacha/Notify')
    },
    {
      path: '/faq/gacha',
      name: 'GachaFaq',
      component: loadView('Gacha/Faq')
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})

/**
 * ページ遷移発生時に実行する処理を記述
 * TODO: analytics処理
 */
router.beforeEach(async (to, from, next) => {
  console.log(to.name)
  console.log(ScreenName[to.name])
  // Tracking screen.
  if (ScreenName[to.name]) {
    console.log(store)
    store.dispatch('Analytics/trackScreen', { name: ScreenName[to.name] })
    // store.dispatch('log/setTrackScreen', Screen[to.name])
  }
  store.dispatch('Analytics/trackEvent', FactoryTrack.createPageView(to, store))
  next()
})

export default router
